import React from 'react';
import { BeltRankValue } from 'app/javascript/types';
import { WhiteBeltSVG, BlueBeltSVG, PurpleBeltSVG, BrownBeltSVG, BlackBeltSVG } from 'app/javascript/components/shared/belts';
import { normalizeBeltRank } from 'app/javascript/services/belts';

interface BeltImageProps {
  rank: BeltRankValue | string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  xs: 'w-8 h-auto',
  sm: 'w-12 h-auto',
  md: 'w-16 h-auto',
  lg: 'w-24 h-auto',
  xl: 'w-32 h-auto',
};

const BeltImage: React.FC<BeltImageProps> = ({ rank, size = 'md', className = '' }) => {
  const combinedClassName = `${sizeClasses[size]} ${className}`;
  const normalizedRank = normalizeBeltRank(rank);
  const ariaLabel = `Faixa ${rank} de Jiu Jitsu`;

  // Map belt ranks to their base color for SVG selection
  // Kids belts (gray, yellow, orange, green) currently use white SVG as placeholder
  // TODO: Add SVGs for kids belts when designs are available
  const renderSvg = () => {
    switch (normalizedRank) {
      case 'blue':
        return <BlueBeltSVG className={combinedClassName} />;
      case 'purple':
        return <PurpleBeltSVG className={combinedClassName} />;
      case 'brown':
        return <BrownBeltSVG className={combinedClassName} />;
      case 'black':
        return <BlackBeltSVG className={combinedClassName} />;
      case 'white':
      case 'gray':
      case 'gray_white':
      case 'gray_black':
      case 'yellow':
      case 'yellow_white':
      case 'yellow_black':
      case 'orange':
      case 'orange_white':
      case 'orange_black':
      case 'green':
      case 'green_white':
      case 'green_black':
      default:
        return <WhiteBeltSVG className={combinedClassName} />;
    }
  };

  return (
    <span role="img" aria-label={ariaLabel} className="inline-flex items-center justify-center">
      {renderSvg()}
    </span>
  );
};

export default BeltImage;
